goog.provide("shadow.js.shim.module$src$svg$person$person_circle_svg$default");
shadow.js.shim.module$src$svg$person$person_circle_svg$default = shadow.js.shim.module$src$svg$person$person_circle_svg.default;
